import React from "react";
import buckedUp from "../assets/buckedup.png";
import buckedUpBabe from "../assets/buckedup-babe.png";
import buckedUpPump from "../assets/buckedup-pump.png";
import buckedUpBcaa from "../assets/buckedup-bcaa.png";
import nutButter from "../assets/nut-butter.png";
import tlfOnsie from "../assets/tlf-onsie.png";
import tlfSportsBra from "../assets/tlf-sports-bar-black.png";
import tlfTempoShorts from "../assets/tlf-tempo-shorts.png";
import tlfFlareLeggings from "../assets/tlf-flare-leggings.png";
import tlfJacket from "../assets/tlf-jacket.png";
import ProductCategory from "./ProductCategory";

const ProductsSection = () => {
    const fits = [
        {
            id: 1,
            title: 'Sculpt Seamless Scrunch Butt Onesie',
            imageUrl: tlfOnsie,
            altText: "",
            brand: "TLF",
            link: 'https://tlfapparel.com/products/tlf-sculpt-seamless-scrunch-butt-onesie-vintage-latte?Color=Vintage+Latte&Size=M',
            affiliateCode: 'BA15FILOMENA',
        },
        {
            id: 2,
            title: 'Tempo Multi-Back Strap Sports Bra',
            imageUrl: tlfSportsBra,
            altText: "",
            brand: "TLF",
            link: 'https://tlfapparel.com/products/tlf-tempo-multi-back-strap-sports-bra-black?Color=Black&Size=M',
            affiliateCode: 'BA15FILOMENA',
        },
        {
            id: 3,
            title: 'Tempo 6 Inch Workout Shorts',
            imageUrl: tlfTempoShorts,
            altText: "",
            brand: "TLF",
            link: 'https://tlfapparel.com/products/tlf-tempo-6-inch-workout-shorts-black?Color=Black&Size=M',
            affiliateCode: 'BA15FILOMENA',
        },
        {
            id: 4,
            title: 'Tempo Flare Legging',
            imageUrl: tlfFlareLeggings,
            altText: "",
            brand: "TLF",
            link: 'https://tlfapparel.com/products/tlf-tempo-flare-legging-dark-oak?Color=Dark+Oak&Size=M',
            affiliateCode: 'BA15FILOMENA',
        },
        {
            id: 5,
            title: 'Tempo Cropped Zip Up Jacket',
            imageUrl: tlfJacket,
            altText: "",
            brand: "TLF",
            link: 'https://tlfapparel.com/products/tlf-tempo-flare-legging-dark-oak?Color=Dark+Oak&Size=M',
            affiliateCode: 'BA15FILOMENA',
        },
        {
            id: 6,
            title: 'Longline Sports Bra for Women V Back Wireless Padded Medium Support Yoga Bra Workout Crop Tank Tops',
            imageUrl: "https://m.media-amazon.com/images/I/71GHJG+WjiL._AC_SY879_.jpg",
            altText: "",
            brand: "ABOCIW",
            link: 'https://amzn.to/3AX9B6a',
            why: 'Looks so cute! True to size for me.',
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 7,
            title: 'Cotton Fleece Lined Sweatpants Women Straight Leg Casual Lounge Sweat Pants for Women',
            imageUrl: "https://m.media-amazon.com/images/I/81som36M0rL._AC_SY879_.jpg",
            altText: "",
            brand: "CRZ YOGA",
            link: 'https://amzn.to/4eJDKUo',
            why: 'I love the CRZ brand! It is basically a lulu dupe. SUPER comfy option!',
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 8,
            title: 'THE GYM PEOPLE Womens\' Sports Bra Longline Wirefree Padded with Medium Support',
            imageUrl: "https://m.media-amazon.com/images/I/61mT0USAW0S._AC_SX679_.jpg",
            altText: "",
            brand: "The GYM People",
            link: 'https://amzn.to/3Z6v9oY',
            why: 'So flattering, good material. It was true to size for me.',
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 9,
            title: 'Womens Butterluxe High Waist Flare Pants 29" / 30.5" / 32" / 33.5" - Wide Leg Bootcut Yoga Pants with Pocket Lounge',
            imageUrl: "https://m.media-amazon.com/images/I/61BcZPTVjiL._AC_SY879_.jpg",
            altText: "",
            brand: "CRZ YOGA",
            link: 'https://amzn.to/4hZD1kT',
            why: 'I love the CRZ brand! It is basically a lulu dupe. Flare pants are in at the moment, I love the ones I have!',
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 10,
            title: 'Womens Zip Up Hoodies Cropped Sweatshirts Fleece Jackets Fall Outfits Casual Hooded Y2k Tops Winter Clothes',
            imageUrl: "https://m.media-amazon.com/images/I/61M51X62I4L._AC_SY879_.jpg",
            altText: "",
            brand: "Trendy Queen",
            link: 'https://amzn.to/4fHZG3u',
            why: 'I\'ve been so happy with this sweatshirt! Totally recommend!',
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 11,
            title: 'Butterluxe Womens Cropped Slim Fit Workout Jackets - Weightless Track Athletic Full Zip Jacket with Thumb Holes',
            imageUrl: "https://m.media-amazon.com/images/I/71tGWOcnDYL._AC_SY879_.jpg",
            altText: "",
            brand: "CRZ YOGA",
            link: 'https://amzn.to/3Z6DJE6',
            why: 'I love the CRZ brand! It is basically a lulu dupe. This sweater is very flattering!',
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 12,
            title: 'Sweatsuits Women 2 Piece Outfit Two Piece Lounge Sets Hoodies and Sweatpants Fall Fashion Clothes 2024 Tracksuit',
            imageUrl: "https://m.media-amazon.com/images/I/51FHjlVAbsL._AC_SY879_.jpg",
            altText: "",
            brand: "Trendy Queen",
            link: 'https://amzn.to/4g3WSxI',
            why: 'I adore this set! It is perfect for fall, winter and spring gym sessions where layers are absolutely needed!',
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 14,
            title: 'Calvin Klein Women\'s Socks - Cushion Athletic Crew Socks (6 Pairs)',
            imageUrl: "https://m.media-amazon.com/images/I/81tc-bnWJ3L._AC_SX679_.jpg",
            altText: "",
            brand: "Calvin Klein",
            link: 'https://amzn.to/41kpMWf',
            why: 'So cute, comfortable and a perfect accessory to most any gym fit.',
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 15,
            title: 'Nike Women\'s Gymnastics Shoes Sneaker',
            imageUrl: "https://m.media-amazon.com/images/I/61TpwR4jLIL._AC_SY695_.jpg",
            altText: "",
            brand: "Nike",
            link: 'https://a.co/d/aZ8Qt1W',
            why: 'I LOVEEE my 270s so much that I\'ve bought three pairs. They are great for running and better for lifting than people think.',
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 16,
            title: 'NIKE Women\'s Shoes',
            imageUrl: "https://m.media-amazon.com/images/I/618FhFPg8+L._AC_SX695_.jpg",
            altText: "",
            brand: "Nike",
            link: 'https://amzn.to/3CHNCAS',
            why: 'So cute and easy to match with most every look, professional and athletic/comfy.',
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 17,
            title: 'Gym Fit Essential',
            imageUrl: "https://m.media-amazon.com/images/I/71TVzco4l-L._AC_SL1500_.jpg",
            altText: "",
            brand: "Amazon",
            link: 'https://amzn.to/4ijBPLU',
            why: 'A great addition to any workout wardrobe!',
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 18,
            title: 'Activewear Find',
            imageUrl: "https://m.media-amazon.com/images/I/618dZvYJ5gL._AC_SL1500_.jpg",
            altText: "",
            brand: "Amazon",
            link: 'https://amzn.to/4A3Cmb1',
            why: 'Comfortable and stylish for the gym!',
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 19,
            title: 'YEOREO SoftHue Women\'s Biker Shorts Workout Hidden Scrunch Gym Shorts High Waist Tummy Control',
            imageUrl: "https://m.media-amazon.com/images/I/61qprQPj3ZL._AC_SL1500_.jpg",
            altText: "",
            brand: "YEOREO",
            link: 'https://amzn.to/3Vjv56Z',
            why: 'Buttery soft with hidden scrunch detail. High waist and tummy control for a flattering fit!',
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 20,
            title: 'YEOREO SoftHue Women\'s Biker Shorts Workout Hidden Scrunch Gym Shorts High Waist Running Shorts',
            imageUrl: "https://m.media-amazon.com/images/I/61N-5YDMlBL._AC_SL1500_.jpg",
            altText: "",
            brand: "YEOREO",
            link: 'https://amzn.to/4xiWFii',
            why: 'No front seam design for ultimate comfort during workouts!',
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 21,
            title: 'YEOREO SoftHue Women\'s Biker Shorts Workout Hidden Scrunch Gym Shorts High Waist Tummy Control',
            imageUrl: "https://m.media-amazon.com/images/I/71fDBv3mAoL._AC_SL1500_.jpg",
            altText: "",
            brand: "YEOREO",
            link: 'https://amzn.to/4qYoxGO',
            why: 'Perfect length options - 3.6", 4.5", or 6" - for any workout style!',
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 22,
            title: 'YEOREO CoreFlex Sports Bras for Women Workout Twist Cross Back Yoga Tops V Neck Padded Low Impact',
            imageUrl: "https://m.media-amazon.com/images/I/71wXj9ODpPL._AC_SL1500_.jpg",
            altText: "",
            brand: "YEOREO",
            link: 'https://amzn.to/4yrFOuy',
            why: 'Beautiful twist cross back design. Adjustable straps and buttery soft fabric!',
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 23,
            title: 'YEOREO SoftHue Women\'s Biker Shorts Workout Hidden Scrunch Gym Shorts High Waist No Front Seam',
            imageUrl: "https://m.media-amazon.com/images/I/61mFC3ENdKL._AC_SL1500_.jpg",
            altText: "",
            brand: "YEOREO",
            link: 'https://amzn.to/46M6IBp',
            why: 'These are a staple in my gym wardrobe - buttery soft and so flattering!',
            isBlackFridayDeal: false,
            isOnSale: false,
        },
    ];

    const supplements = [
        {
            id: 1,
            title: 'Calum Von Moger Pre-Workout - Koala Freak',
            imageUrl: buckedUp,
            altText: 'Wanna train like the 3X Mr. Universe? From the Koala Freak himself comes 2 exclusive signature flavors in Calum’s favorite Bucked Up Pre-workout formulas.',
            brand: 'Bucked Up',
            link: "https://www.buckedup.com/shop/bucked-up-pre-workout/pre-koala-freak", //https://www.buckedup.com/?uid_m=304891",
            affiliateCode: 'FILOMENA'
        },
        {
            id: 2,
            title: 'Babe Pre-Workout',
            imageUrl: buckedUpBabe,
            altText: 'All that you’d expect from a Bucked Up Pre-Workout, like sufficient doses of beta-alanine for strength, recovery, and endurance.  Babe Pre-Workout doesn\'t stop there — it\'s also packed with hyaluronic acid and biotin to give you that glow you dream of. All these elements combine to form the best pre-workout for women. Period.',
            brand: 'Bucked Up',
            link: "https://www.buckedup.com/shop/bucked-up-pre-workout/babe-pre-workout-supplement", //https://www.buckedup.com/?uid_m=304891",
            affiliateCode: 'FILOMENA'
        },
        {
            id: 3,
            title: 'PUMP-OCALYPSE',
            imageUrl: buckedUpPump,
            altText: 'Ever feel like you could be getting more out of your workouts? Have you hit a plateau and wondered if you lost your edge? Do you want to experience your body’s true potential? Chasing that better pump? If you said yes to any of those questions, PUMP-OCALYPSE is the best option for you.',
            brand: 'Bucked Up',
            link: "https://www.buckedup.com/shop/bucked-up-pre-workout/bucked-up-pump-ocalypse", //https://www.buckedup.com/?uid_m=304891",
            affiliateCode: 'FILOMENA'
        },
        {
            id: 4,
            title: 'Original BCAA 2:1:1',
            imageUrl: buckedUpBcaa,
            altText: 'Train harder, break through plateaus and recover faster with our Original BCAA Powder.\n' +
                '\n' +
                'Do you feel rundown, beat down, or constantly sluggish from (or during) your workouts? We got ya. Our Branched Chain Amino Acid supplement will help you go even harder during your intense workout without getting nearly as fatigued or sore days after.*\n' +
                '\n' +
                'Fuel muscle tissue growth, accelerate recovery, increase muscular endurance.* Our BCAA powder is the ultimate key to unlocking your goals.*',
            brand: 'Bucked Up',
            link: "https://www.buckedup.com/original-bcaa-2-1-1", //https://www.buckedup.com/?uid_m=304891",
            affiliateCode: 'FILOMENA'
        },
        {
            id: 5,
            title: 'Nutricost Creatine Monohydrate Micronized Powder 500G, 5000mg Per Serv (5g) - Micronized Creatine Monohydrate, 100 Servings, 17.9 Oz',
            imageUrl: "https://m.media-amazon.com/images/I/61x5fvmyaaL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Nutricost',
            link: "https://amzn.to/4i1w0jy",
            why: 'Creatine is one of the those tried and true, proven supplements that help you build muscle. Yes, women take creatine too. Creatine Monohydrate is the best type because it is the most well-researched.',
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 6,
            title: 'Ultima Replenisher Mocktini Electrolyte Drink Mix – Peach Bellini, 90 Servings – Hydration Powder with 6 Key Electrolytes & Trace Minerals – Keto Friendly, Non- GMO & Sugar-Free Electrolyte Powder',
            imageUrl: "https://m.media-amazon.com/images/I/61ZM5X01C-L._SL1500_.jpg",
            altText: '',
            brand: 'Ultima Replenisher',
            link: "https://amzn.to/4hVVG17",
            why: 'I used to love gatorade as a source to replenish electrolytes. But no more, this is a cleaner, better source. I personally prefer the large container rather than individual packets but to each her own.',
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 7,
            title: 'Ultima Replenisher Daily Electrolyte Drink Mix – Original Variety, 20 Stickpacks – Hydration Packets with 6 Electrolytes & Minerals – Keto Friendly, Vegan, Non- GMO & Sugar-Free Electrolyte Powder',
            imageUrl: "https://m.media-amazon.com/images/I/71yIVO771yL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Ultima Replenisher',
            link: "https://amzn.to/3V5PGcg",
            why: 'I used to love gatorade as a source to replenish electrolytes. But no more, this is a cleaner, better source.',
            isBlackFridayDeal: false,
            isOnSale: false,
        },
        {
            id: 8,
            title: 'Better Oats 100 Calorie Maple and Brown Sugar Oatmeal Packets, 100 Calorie Oatmeal Pouches, 90 Second Instant Oatmeal with Flax Seeds and Rolled Oats, Pack of 6, 9.8 OZ Pack',
            imageUrl: "https://m.media-amazon.com/images/I/611-mXDNi3L._SL1001_.jpg",
            altText: '',
            brand: 'Better Oats',
            link: "https://amzn.to/3OlDHTU",
            why: '"YOUR BODY NEEDS CARBS! YOUR BRAIN LITERALLY RUNS ON GLUCOSE!" What movie is that from? :) But seriously, it is true. This is a perfect pre-workout meal or breakfast option.',
            isBlackFridayDeal: false,
            isOnSale: true,
        },
        {
            id: 9,
            title: 'Magnesium (Glycinate) - Supplement to Support Stress Relief, Sleep, Heart Health, Nerves, Muscles, and Metabolism* - with Magnesium Glycinate - 180 Capsules',
            imageUrl: "https://m.media-amazon.com/images/I/71dUHbn4-jL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Pure Encapsulations',
            link: "https://amzn.to/4fFLJmQ",
            why: 'Your body NEEDS magnesium. Just do it! I take nearly all of my vitamins and other supplements just after my morning workouts.',
            isBlackFridayDeal: false,
            isOnSale: true,
        },
        {
            id: 10,
            title: 'Omega 3 Fish Oil - 2500MG, 120 Softgels (40 Serv) - Fish Oil, Wild Caught! 1200mg EPA 850mg DHA - Non-GMO, Gluten Free',
            imageUrl: "https://m.media-amazon.com/images/I/61DE6L9wduL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Nutricost',
            link: "https://amzn.to/3V6mvWh",
            why: 'Your body benefits in so many ways from taking omega 3s. This supplement is from wild caught fish, ' +
                'which is awesome! Good for help with managing cholesterol, brain health, and so much more. I take them ' +
                'just after my workout in the morning usually.',
            isBlackFridayDeal: false,
            isOnSale: true,
        },
        {
            id: 11,
            title: 'Multivitamin with Probiotics 120 Vegetarian Capsules - Packed with Vitamins & Minerals',
            imageUrl: "https://m.media-amazon.com/images/I/61ub-QBs59L._AC_SL1500_.jpg",
            altText: '',
            brand: 'Nutricost',
            link: "https://amzn.to/3Zi0mXI",
            why: 'Your gut will thank you!',
            isBlackFridayDeal: false,
            isOnSale: true,
        },
        {
            id: 12,
            title: 'Ashwagandha Herbal Supplement 600mg, 120 Capsules - Vegetarian, Non-GMO, Gluten Free, Ashwagandha Root',
            imageUrl: "https://m.media-amazon.com/images/I/616O2S1uCpL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Nutricost',
            link: "https://amzn.to/3V5hIEP",
            why: 'Helps body cope with stress and promotes overall well-being. I generally take it after my workout and breakfast.',
            isBlackFridayDeal: false,
            isOnSale: true,
        },
    ];

    const proteins = [
        {
            id: 1,
            title: 'Fairlife Nutrition Plan High Protein Chocolate Shake, 12 pk. B (Pack of 3)',
            imageUrl: 'https://m.media-amazon.com/images/I/51seCu1hQlL._SX679_.jpg',
            altText: "",
            brand: "Fairlife",
            link: 'https://amzn.to/4931yBs',
            why: 'An awesome bulk option! Fairlife is the yummiest. You can also buy these at Costco, but for some Costco\'s, they are only in stock sporadically.',
            isBlackFridayDeal: false,
        },
        {
            id: 2,
            title: 'Cinnamon Bun Protein Cashew Butter',
            imageUrl: nutButter,
            altText: '',
            brand: 'PartyPumpCo',
            link: "https://partypumpco.com/products/cinnamon-bun-protein-cashew-butter",
            affiliateCode: 'AMANDA1'
        },
        {
            id: 3,
            title: "OWYN Only What You Need Pro Elite Vegan High Protein Keto Shake, 32g Protein, 9 Amino Acids, Omega-3, Prebiotics, Workout and Recovery, 0g Net Carbs, Zero Sugar (Variety, 12 Fl Oz (Pack of 12))",
            imageUrl: "https://m.media-amazon.com/images/I/41Y-u+fz-4L.jpg",
            altText: "OWYN Only What You Need Protein Shake",
            brand: "OWYN Only What You Need",
            link: "https://amzn.to/4eFopo1",
            why: 'A very good choice if you are lactose intolerant or otherwise! This protein tastes amazing! Having individual drinks is convenient and amazing!',
            isBlackFridayDeal: false,
        },
        {
            id: 4,
            title: 'OWYN Pro Elite Vegan 30g Plant-Based High Protein Powder',
            imageUrl: 'https://m.media-amazon.com/images/I/81NnyqxrDVL._AC_SX679_.jpg',
            altText: "OWYN Only What You Need Protein Shake",
            brand: "OWYN Only What You Need",
            link: 'https://amzn.to/4g2349b',
            why: 'A very good choice if you are lactose intolerant or otherwise! This protein tastes amazing!',
            isBlackFridayDeal: false,
        },
        {
            id: 0,
            title: 'Premier Protein Shake, Chocolate, 30g Protein 1g Sugar 24 Vitamins Minerals Nutrients to Support Immune Health, 11.5 fl oz (Pack of 12)',
            imageUrl: "https://m.media-amazon.com/images/I/719eDVmYeYL._SL1500_.jpg",
            altText: "",
            brand: "Premier",
            link: 'https://amzn.to/3ZlZ1iK',
            isPrimeDayDeal: false,
            why: 'I use these everyday in my shakes. Fairlife is my main favorite, but these are a close second.',
            isBlackFridayDeal: false,
        },
        {
            id: 6,
            title: 'Kodiak Cakes Protein Pancake Power Cakes, Flapjack and Waffle Baking Mix, Buttermilk, 20 Oz, (Pack of 6)',
            imageUrl: "https://m.media-amazon.com/images/I/91cEnVbVHpL._SL1500_.jpg",
            altText: "",
            brand: "Kodiak Cakes",
            link: 'https://amzn.to/4fYSe3S',
            why: 'I always make sure to have some of this mix in my pantry. Great for the family. So easy and yummy.',
            isBlackFridayDeal: false,
        },
        {
            id: 7,
            title: 'FITCRUNCH Snack Size Protein Bars, Designed by Robert Irvine, 6-Layer Baked Bar, 3g of Sugar, Gluten Free & Soft Cake Core (9 Count, Flavor Lovers)',
            imageUrl: "https://m.media-amazon.com/images/I/91PHcXAWx9L._SL1500_.jpg",
            altText: "",
            brand: "Fit Crunch",
            link: 'https://amzn.to/412l0fz',
            why: 'My very favorite protein bars. These are so tasty! Protein bars should never ben your main source of protein, but this is a good, quick supplement to meet your goals!',
            isBlackFridayDeal: false,
        },
        {
            id: 8,
            title: 'Come Ready Nutrition Clean Protein Bars (2 pack) 48 Total Bars - 24 Chocolate Sea Salt and 24 Chocolate Peanut Butter ONLY $1.38/Bar',
            imageUrl: "https://m.media-amazon.com/images/I/71FQHQCX8iL._SL1280_.jpg",
            altText: "",
            brand: "Clean Protein Bars",
            link: 'https://amzn.to/3CH2oYB',
            why: 'My second favorite protein bars! These are like healthy rice krispies. Always delicious!',
            isBlackFridayDeal: false,
        },
    ];

    const equipment = [
        {
            id: 10,
            title: 'Tote Bag for Women, Lightweight Puffy Tote Bag with Compartments, Quilted Shoulder Bag Handbag for Travel, Work',
            imageUrl: "https://m.media-amazon.com/images/I/61T6E3Jv1sL._AC_SX679_.jpg",
            altText: "",
            brand: "Bagsmart",
            link: 'https://amzn.to/3Z0VUv2',
            isPrimeDayDeal: false,
            why: 'Carry your gym goodies with you. I do not go to the gym without a bag these days. It is just too convenient.',
            isBlackFridayDeal: false,
        },
        {
            id: 21,
            title: 'Beats Studio Pro x Kim Kardashian – Bluetooth Noise Cancelling Headphones, Personalized Spatial Audio, USB-C Lossless Audio, Apple & Android Compatibility, Up to 40 Hours Battery Life - Dune',
            imageUrl: "https://m.media-amazon.com/images/I/515dNUIrGzL._AC_SL1500_.jpg",
            altText: "",
            brand: "Beats",
            link: 'https://amzn.to/4eHUETA',
            isPrimeDayDeal: false,
            why: 'Step up your audio experience with these stylish, noise-canceling headphones designed to keep you immersed in your music or work with exceptional clarity.',
            isBlackFridayDeal: false,
        },
        {
            id: 2,
            title: 'Apple Watch SE (2nd Gen) [GPS 40mm] Smartwatch with Starlight Aluminium Case with Starlight Sport Band S/M. Fitness and Sleep Trackers, Crash Detection, Heart Rate Monitor, Retina Display',
            imageUrl: "https://m.media-amazon.com/images/I/61umEhyV-UL._AC_SL1500_.jpg",
            altText: "",
            brand: "Apple",
            link: 'https://amzn.to/4g0ZrAA',
            isPrimeDayDeal: false,
            why: 'Perfect for busy women who value wellness and efficiency. I use this everyday!',
            isBlackFridayDeal: false,
        },
        {
            id: 3,
            title: 'Apple AirPods Pro 3 Wireless Earbuds with Active Noise Cancellation, Live Translation, Heart Rate Sensing, Spatial Audio, USB-C Charging',
            imageUrl: "https://m.media-amazon.com/images/I/61SUj2aKoEL._AC_SL1500_.jpg",
            altText: "",
            brand: "Apple",
            link: 'https://amzn.to/4idQvvX',
            isPrimeDayDeal: false,
            why: 'The latest AirPods Pro with incredible features like live translation and heart rate sensing. A must-have upgrade!',
            isBlackFridayDeal: false,
        },
        {
            id: 2,
            title: 'POWER GUIDANCE LAT Pulldown Attachments, Pull Down Bar with Ergonomic Handle, Cable Machine Attachments for More Effective and Less Fatigued Grip',
            imageUrl: "https://m.media-amazon.com/images/I/51s-dTEq5qL._AC_SX679_.jpg",
            altText: "",
            brand: "POWER GUIDANCE",
            link: 'https://amzn.to/4hZkchI',
            isPrimeDayDeal: false,
            why: 'Take your upper body training to the next level with this ergonomic attachment, designed to provide a comfortable, efficient workout while minimizing fatigue.',
            isBlackFridayDeal: false,
        },
        {
            id: 1,
            title: 'Resistance Bands for Working Out with Workout Bands Guide. 4 Booty Bands for Women Men Fabric Elastic Bands for Exercise Bands Resistance Bands for Legs Bands for Working Out Hip Thigh Glute Bands Set',
            imageUrl: "https://m.media-amazon.com/images/I/61EOg1hmbJL._AC_SL1432_.jpg", // Assuming this is the correct image URL
            altText: "",
            brand: "Vergali",
            link: 'https://amzn.to/4hYt4UP',
            isPrimeDayDeal: false,
            why: 'I use these almost every legs & glutes day. Side stepping with these bands are the perfect warm up.',
            isBlackFridayDeal: false,
        },
        {
            id: 3,
            title: 'ProFitness Barbell Pad Squat Pad- Shoulder Support for Squats, Lunges & Hip Thrusts - For Olympic or Standard Bars',
            imageUrl: "https://m.media-amazon.com/images/I/51gcN4V9lIL._AC_SX679_.jpg",
            altText: "",
            brand: "ProFitness",
            link: 'https://amzn.to/3CSDHbu',
            isPrimeDayDeal: false,
            why: 'Must have for hip thrusties!',
            isBlackFridayDeal: false,
        },
        {
            id: 4,
            title: 'ProFitness Weight Lifting Straps - 10” Long Wrist Straps for Weightlifting - Padded Neoprene Lifting Straps Gym with Non Slip Silicone Grip Men and Women - Weightlifting Wrist Straps',
            imageUrl: "https://m.media-amazon.com/images/I/71D9orDO2cL._AC_SL1500_.jpg",
            altText: "",
            brand: "ProFitness",
            link: 'https://amzn.to/3YZFXoR',
            isPrimeDayDeal: false,
            why: 'Lift heavier with confidence using these padded, non-slip wrist straps that support your grip during intense lifting sessions.',
            isBlackFridayDeal: false,
        },
        {
            id: 5,
            title: 'Ankle Strap for Cable Exercise Machines, Work Out Cuff Attachment for Home & Gym, Glute Workouts - Kickbacks, Leg Extensions, Hip Abductors, for Exercise Machine Attachments',
            imageUrl: "https://m.media-amazon.com/images/I/71mlZwNHQ8L._AC_SL1344_.jpg",
            altText: "",
            brand: "Fitgirl",
            link: 'https://amzn.to/3CHrW7S',
            isPrimeDayDeal: false,
            why: 'Target your glutes and legs with these adjustable, padded ankle straps. I have the Gymreaper brand which I love but these have better deals!',
            isBlackFridayDeal: false,
        },
        {
            id: 6,
            title: 'Self-Locking Weight Lifting Belt - Premium Weightlifting Belt for Serious Functional Fitness, Weight Lifting, and Olympic Lifting Athletes - Lifting Support for Men and Women - Deadlift Training Belt',
            imageUrl: "https://m.media-amazon.com/images/I/71Z+5gGXiEL._AC_SL1377_.jpg",
            altText: "",
            brand: "Element 26",
            link: 'https://amzn.to/3V4IdtW',
            isPrimeDayDeal: false,
            why: 'Support your lifts and prevent injury with this high-quality, self-locking lifting belt—designed for serious weightlifting and functional fitness athletes.',
            isBlackFridayDeal: false,
        },
        {
            id: 20,
            title: 'Fitness Olympic Barbell Clamps Collars Quick Release Pair of Locking Weight Clips Fit 2 Inch Barbell for Weightlifting',
            imageUrl: "https://m.media-amazon.com/images/I/61EOg1hmbJL._AC_SL1432_.jpg",
            altText: "",
            brand: "Clout",
            link: 'https://amzn.to/3Z295Mh',
            isPrimeDayDeal: false,
            why: 'I use these so often! Your gym bag needs them.',
            isBlackFridayDeal: false,
        },
        {
            id: 7,
            title: 'Nippies Nipple Cover - Sticky Adhesive Silicone Nipple Pasties - Reusable Pasty Nipple Covers for Women with Travel Box',
            imageUrl: "https://m.media-amazon.com/images/I/81TgvZ35BhL._AC_SX679_.jpg",
            altText: "",
            brand: "Nippies",
            link: 'https://amzn.to/3VrM2K3',
            isPrimeDayDeal: false,
            why: 'Game changer! I have started just throwing out my sports-bra inserts. These are so nice to have!',
            isBlackFridayDeal: false,
        },
        {
            id: 8,
            title: 'Seamless Women Underwear Thongs, No Show Ladies Thong, No Line Breathable Comfortable Panties Undies for Women 5-Pack',
            imageUrl: "https://m.media-amazon.com/images/I/71jGIvy-lCL._AC_SX679_.jpg",
            altText: "",
            brand: "voenxe",
            link: 'https://amzn.to/3CDytk9',
            isPrimeDayDeal: false,
            why: 'Helps with cameltoe! Wear under your colorful leggings.',
            isBlackFridayDeal: false,
        },
        {
            id: 9,
            title: '2-in-1 Magnetic Charging Dock for Ray-Ban Meta Glasses with 15W Adapter',
            imageUrl: "https://m.media-amazon.com/images/I/61bcNLe6qrL._AC_SL1500_.jpg",
            altText: "",
            brand: "Ray-Ban Meta",
            link: 'https://amzn.to/4yrEyYb',
            isPrimeDayDeal: false,
            why: 'Perfect charging solution for my Ray-Ban Meta glasses. Keeps them charged and ready to go!',
            isBlackFridayDeal: false,
        }
    ];

    const supplies = [
        {
            id: 1,
            title: 'Ninja CREAMi, Ice Cream Maker, Ice Cream, Gelato, Sorbet, Milkshakes, Mix-ins, Smoothie Bowls & More, 7-in-1, Ice Cream Pints, Pint lid, Healthy Ice Cream, Compact, Perfect for Kids, Black, NC299AMZ',
            imageUrl: "https://m.media-amazon.com/images/I/71dlGPGK7WL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Ninja',
            link: "https://amzn.to/3Zi1335",
            isPrimeDayDeal: false,
            why: "I love this because it lets me make healthier versions of my favorite desserts at home. My husband and daughter love it, and it's easy to clean, making it perfect for busy moms!",
            isBlackFridayDeal: false,
        },
        {
            id: 2,
            title: 'for Ninja Creami Pints and Lids - 4 Pack,16OZ Compatible with NC299AMZ & NC300s Series Ice Cream Makers, Extra Cups Replacement for Ninja Creamy Containers Airtight Anti-slip Dishwasher Safe',
            imageUrl: "https://m.media-amazon.com/images/I/71UNJgMiWBL._AC_SL1500_.jpg",
            altText: '',
            brand: 'DENEBORE',
            link: "https://amzn.to/3V31MTi",
            isPrimeDayDeal: false,
            why: "These pints are perfect for making multiple batches of your favorite ice creams without constantly having to wash the cups. They're airtight, so everything stays fresh!",
            isBlackFridayDeal: false,
        },
        {
            id: 3,
            title: 'Ninja Air Fryer, Roast, Bake, Air Fry, Roast, Broil, Reheats, & Dehydrates, 4-in-1, Fries, Frozen Food, Veggies, and Juicy Meat, Less Oil, Easy Meals, Healthy Meals, Compact, 4 QT, Grey, AF101',
            imageUrl: "https://m.media-amazon.com/images/I/71+8uTMDRFL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Ninja',
            link: "https://amzn.to/4g1pQOn",
            isPrimeDayDeal: false,
            why: "I love how easy this air fryer makes it to make healthy meals without sacrificing flavor. It cuts down on cooking time, and it's perfect for quick weeknight dinners!",
            isBlackFridayDeal: false,
        },
        {
            id: 4,
            title: 'Blackstone 1883 Original 28” Griddle with Integrated Protective Hood and Counter Height Side Shelves, Powder Coated Steel',
            imageUrl: "https://m.media-amazon.com/images/I/81+xTkaLKVS._AC_SL1500_.jpg",
            altText: '',
            brand: 'Blackstone',
            link: "https://amzn.to/3AWUTfx",
            isPrimeDayDeal: false,
            why: "Perfect for outdoor cooking! I love how versatile this griddle is for family meals or when hosting friends. It's large enough for big batches and makes grilling fun!",
            isBlackFridayDeal: false,
        },
        {
            id: 5,
            title: 'HOMBERKING 10 Pack Glass Meal Prep Containers 2 Compartment, Glass Food Storage Containers with Lids, Airtight Glass Lunch Bento Boxes, BPA-Free & Leak Proof (10 lids & 10 Containers)',
            imageUrl: "https://m.media-amazon.com/images/I/81LglC3AwVL._AC_SL1500_.jpg",
            altText: '',
            brand: 'HOMBERKING',
            link: "https://amzn.to/4i23OgA",
            isPrimeDayDeal: false,
            why: "Meal prepping is key to a positive and effective week, and these glass containers are perfect for keeping everything fresh. Plus, they're easy to store and reduce waste. Great for busy professionals and moms!",
            isBlackFridayDeal: false,
        },
        {
            id: 6,
            title: 'DRKIO 4 Pack Overnight Oats Containers with Lids and Spoons 16 Oz Glass Mason Jars for Overnight Oats Leak Proof Oatmeal Container Great for Cereal Fruit Vegetable Milk Salad Yogurt Meal Prep',
            imageUrl: "https://m.media-amazon.com/images/I/71qk8RTV-cL._AC_SL1500_.jpg",
            altText: '',
            brand: 'DRKIO',
            link: "https://amzn.to/4i4f9wD",
            isPrimeDayDeal: false,
            why: "These overnight oats containers are the perfect solution for busy mornings. They keep my oats fresh and are super easy to carry on the go!",
            isBlackFridayDeal: false,
        },
        {
            id: 7,
            title: 'Ninja Blender, Food Processor, Blender for-Smoothies, Includes Pitcher, Smoothie Cup, and 8-Cup Bowl, Salsa, Dough, Shakes, Slush, and Frozen Drinks, Mega Kitchen System, Black, BL770AMZ',
            imageUrl: "https://m.media-amazon.com/images/I/81ihuPP1L8L._AC_SL1500_.jpg",
            altText: '',
            brand: 'Ninja',
            link: "https://amzn.to/493QdRR",
            isPrimeDayDeal: false,
            why: "This Ninja blender is amy togo for protein shakes and smoothies. I literally take it with my on vacation. I love it that much. It's powerful enough to break down tough ingredients, and the extra smoothie cup is perfect for on-the-go!",
            isBlackFridayDeal: false,
        },
        {
            id: 8,
            title: '15Pcs Pots and Pans Set Non Stick, Cookware Sets with Detachable Handle, Nonstick RV Kitchen Cooking Set Removable Handles, Oven Safe, Induction Fast, Stackable Non-stick Set, White',
            imageUrl: "https://m.media-amazon.com/images/I/61K-NjPXCUL._AC_SL1500_.jpg",
            altText: '',
            brand: 'SODAY',
            link: "https://amzn.to/414i5Dr",
            isPrimeDayDeal: false,
            why: "I love this cookware set because it's space-saving and versatile. The removable handles are perfect for easy storage, and it works perfectly on induction cooktops.",
            isBlackFridayDeal: false,
        },
        {
            id: 9,
            title: 'RENPHO Food Scale, Kitchen Scale for Grams and Ounces, Smart Gram Scale with Nutritional Calculator, Digital Food Weight Scale with App for Macro Keto Weight Loss, White, 11lb/5kg',
            imageUrl: "https://m.media-amazon.com/images/I/71VND9+-AML._AC_SL1500_.jpg",
            altText: '',
            brand: 'Renpho',
            link: "https://amzn.to/4fY6p9n",
            isPrimeDayDeal: false,
            why: "This scale is amazing for tracking meals and keeping my macros in check. The nutritional calculator is a game-changer for anyone serious about their health journey!",
            isBlackFridayDeal: false,
        },
        {
            id: 10,
            title: 'RENPHO Smart Scale for Body Weight, FSA HSA Eligible, Digital Bathroom Scale BMI Weighing Bluetooth Body Fat Scale, Body Composition Monitor Health Analyzer with Smartphone App, 400 lbs - Elis 1',
            imageUrl: "https://m.media-amazon.com/images/I/61bAnOXDl7L._SL1500_.jpg",
            altText: '',
            brand: 'Renpho',
            link: "https://amzn.to/410Ct8s",
            isPrimeDayDeal: false,
            why: "I’ve been using this scale for a while now, and I love how it tracks my body composition beyond just weight. It syncs with the app and helps me stay motivated with real-time data.",
            isBlackFridayDeal: false,
        },
        {
            id: 11,
            title: 'TOLOCO Massage Gun, Deep Tissue Back Massage for Athletes for Pain Relief, Percussion Massager with 10 Massages Heads & Silent Brushless Motor, Black',
            imageUrl: "https://m.media-amazon.com/images/I/71QPvYnRg2L._AC_SL1500_.jpg",
            altText: '',
            brand: 'TOLOCO',
            link: "https://amzn.to/3V5ajVM",
            isPrimeDayDeal: false,
            why: "A must-have for recovery! This massage gun is super effective for sore muscles after lifting or intense workouts. It's affordable and has multiple attachments for all kinds of muscle tension.",
            isBlackFridayDeal: false,
        },
        {
            id: 12,
            title: 'RENPHO Eye Massager with Heat and Cooling FSA HSA, Eyeris 3 Eye Massager for Migraine with Voice Control, Removable Gel Pack, Eye Care Device with Compression for Eye Strain Relief, Eye Relaxation',
            imageUrl: "https://m.media-amazon.com/images/I/61ub55Fu7BL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Renpho',
            link: "https://amzn.to/3V4VL8O",
            isPrimeDayDeal: false,
            why: "I love how this eye massager helps relieve eye strain from long hours in front of the computer. The heat and cooling feature make it feel like a spa experience at home!",
            isBlackFridayDeal: false,
        },
        {
            id: 13,
            title: 'Anysig 8 Pack Fridge Fruit Storage Containers with Removable Colander, Airtight Storage Container',
            imageUrl: "https://m.media-amazon.com/images/I/718Ofo519ML._AC_SL1500_.jpg",
            altText: '',
            brand: 'Anysig',
            link: "https://amzn.to/4xJ8vmC",
            isPrimeDayDeal: false,
            why: "These keep my berries and fruit so fresh! The removable colander makes washing and storing so easy.",
            isBlackFridayDeal: false,
        },
        {
            id: 14,
            title: 'Wildone Mixing Bowls with Airtight Lids, Stainless Steel Set with 3 Grater Attachments & Non-Slip Bottoms',
            imageUrl: "https://m.media-amazon.com/images/I/71fADdT2Q8L._AC_SL1500_.jpg",
            altText: '',
            brand: 'Wildone',
            link: "https://amzn.to/4yrG5xA",
            isPrimeDayDeal: false,
            why: "Love this mixing bowl set! The grater attachments are so useful and the non-slip bottoms make meal prep a breeze.",
            isBlackFridayDeal: false,
        },
        {
            id: 15,
            title: 'Meat Chopper Ground Beef Masher Tool for Hamburger, 5 Curve Blades Heat Resistant Meat Masher',
            imageUrl: "https://m.media-amazon.com/images/I/51wRBxft6KL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Generic',
            link: "https://amzn.to/4yiD9TK",
            isPrimeDayDeal: false,
            why: "A kitchen game changer! Makes breaking up ground beef so much faster and easier.",
            isBlackFridayDeal: false,
        }
    ];

    const officeSupplies = [
        {
            id: 1,
            title: 'Walking Pad, Under Desk Treadmills for Home, 340 Lbs Capacity, 3 in 1 Portable Treadmill',
            imageUrl: "https://m.media-amazon.com/images/I/61E-t1xEXFL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Sperax',
            link: "https://amzn.to/3AWvDpH",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Stay active while working from home. This treadmill fits under your desk, so you can walk and work at the same time—no excuses! Lock in.'
        },
        {
            id: 6,
            title: 'Electric Standing Desk Adjustable Height Sit Stand Home Office Desk with Splice Board',
            imageUrl: "https://m.media-amazon.com/images/I/71JQqX1PchL._AC_SL1500_.jpg",
            altText: '',
            brand: 'STARY',
            link: "https://amzn.to/48ZXdik",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Love the love and functionality. Say goodbye to sitting all day! This adjustable desk lets you alternate between standing and sitting, helping you improve posture and stay energized during long work hours. A game changer for remote work!'
        },
        {
            id: 16,
            title: 'Dell 27 inch S2722QC Monitor | 4K, UHD (3840 x 2160) | 60Hz | 8MS Grey-to-Grey | 1.07 Billion Colors | USB-C | Built-in Dual 3W Speakers | Platinum Silver',
            imageUrl: "https://m.media-amazon.com/images/I/71n0KOE9zhL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Dell',
            link: "https://amzn.to/3Ol26cn",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'I love my dell monitors. Multitask in style. This high-resolution monitor is perfect for work, video calls, or even content creation, making it an ideal addition to your home office.'
        },
        {
            id: 4,
            title: 'Wireless Bluetooth Keyboard and Mouse Combo (USB + Dual BT), seenda Multi-Device Rechargeable Slim Keyboard and Mouse, Compatible for Win 7/8/10, MacBook Pro/Air, iPad, Tablet - Black Gray',
            imageUrl: "https://m.media-amazon.com/images/I/611WpNQHZ-L._AC_SL1500_.jpg",
            altText: '',
            brand: 'seeda',
            link: "https://amzn.to/3UYlTlt",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Ulta slim, Slick and easy to connect and charge!'
        },
        {
            id: 2,
            title: 'A2 Plus Wireless Bluetooth Desktop Speakers - 60W Computer Speakers for Music and Gaming',
            imageUrl: "https://m.media-amazon.com/images/I/81qXbjVEuhL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Audioengine',
            link: "https://amzn.to/3AU3KP1",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Work should feel like a vibe. These Bluetooth speakers offer amazing sound for your work playlist or your downtime music to keep you motivated.'
        },
        {
            id: 3,
            title: 'Apple 2024 MacBook Pro Laptop with M4 Pro, 14‑core CPU, 20‑core GPU: Built for Apple Intelligence, 16.2-inch Liquid Retina XDR Display, 24GB Unified Memory, 512GB SSD Storage; Space Black',
            imageUrl: "https://m.media-amazon.com/images/I/61hw7aZWYSL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Apple',
            link: "https://amzn.to/3Z3G7vH",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'As a boss woman, you need a device that works as hard as you do. This MacBook Pro is powerful, and perfect for both work and creativity—whether you’re running a business or managing a busy home.'
        },
        {
            id: 5,
            title: 'Executive Khaki Office Chair | Leather | High Back | Adjustable | Swivel | Padded Armrest | 350lbs Load-Bearing | Spring Seat | Home Office',
            imageUrl: "https://m.media-amazon.com/images/I/6109SFD55iL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Hoxne',
            link: "https://amzn.to/3V3K561",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'This chair supports you through long hours of work. Its sleek design and ergonomic features make it perfect for the boss who wants comfort and style while running a business from home.'
        },
        {
            id: 7,
            title: 'Leather Desk Pad Protector, Office Desk Mat, Large Mouse Pad, Non-Slip PU Leather Desk Blotter, Laptop Desk Pad, Waterproof Desk Writing Pad for Office and Home (Khaki, 31.5" x 15.8")',
            imageUrl: "https://m.media-amazon.com/images/I/71u6N8i9LYL._AC_SL1500_.jpg",
            altText: '',
            brand: 'YSAGi',
            link: "https://amzn.to/3AVWKkO",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'For the woman who loves a clean, organized workspace, like me! This stylish leather desk pad not only protects your desk but also adds a polished touch to your home office.'
        },
        {
            id: 8,
            title: 'Mechanical Calculator 12 Digit Extra Large 5-Inch LCD Display, DECKLIT Battery Desk Calculator, Big Buttons Easy to Press Office Calculators Desktop, 15°Tilt Screen for Kids Calculator(Gradient Pink)',
            imageUrl: "https://m.media-amazon.com/images/I/71R9rQB2aoL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Decklit',
            link: "https://amzn.to/3AWUvxB",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'For the woman who loves precision and a pop of color. This large-display calculator is perfect for handling work tasks or helping with household budgeting, all while looking cute on your desk.'
        },
        {
            id: 9,
            title: 'Frameo Digital Picture Frame 10.1 inch Digital Photo Frame with 1920 * 1200 IPS Full HD Touchscreen, 16GB WiFi Digital Picture Frame, Share Photos or Videos Instantly via Frameo App from Anywhere',
            imageUrl: "https://m.media-amazon.com/images/I/71fdiv1dZWL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Frameo',
            link: "https://amzn.to/490CFq8",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'This is my preferred way to keep family memories close. It is so nice to be able to update and rotate images.'
        },
        {
            id: 10,
            title: '11x14 Picture Frames 4 Pack Display Pictures 5x7/8x10 with Mat or 11x14 Without Mat Made of Solid Wood Covered by Plexiglass for Table Top Display and Wall Mounting Photo Frame, Light Brown',
            imageUrl: "https://m.media-amazon.com/images/I/61WLZVzXSAL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Egofine',
            link: "https://amzn.to/4eNnZMe",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'I love to surround myself with memories. These picture frames will keep your most cherished moments in view, adding a warm touch to any space in your home.'
        },
        {
            id: 11,
            title: 'Gorilla Grip Silky Gel Memory Foam Wrist Rest for Computer Keyboard, Mouse, Ergonomic Design for Typing Pain Relief, Desk Pads Support Hand and Arm, Mousepad Rests, Stain Resistant, 2 Piece Pad, Black',
            imageUrl: "https://m.media-amazon.com/images/I/61DIPvJYaML._AC_SL1000_.jpg",
            altText: '',
            brand: 'Gorilla Grip',
            link: "https://amzn.to/4ePSx04",
            isBlackFridayDeal: false,
            why: 'Because comfort should always come first. If you are like me and are on your computer for a large portion of your work day, this is a fun, nice-to-have!'
        },
        {
            id: 12,
            title: 'Wireless Charging Station for Magsafe Charger, Charging Station for Multiple Devices, Wireless Charger for iPhone 16/15/14/13/12 Series, Apple Watch Series 1-9, AirPods with LED and Adapter (Black)',
            imageUrl: "https://m.media-amazon.com/images/I/71JsdkTXb2L._AC_SL1500_.jpg",
            altText: '',
            brand: 'EXW',
            link: "https://amzn.to/3Zgqwdn",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Stay organized and ready to go. This charging station is perfect for a busy woman who needs to power up multiple devices at once—without the mess of cords and clutter.'
        },
        {
            id: 13,
            title: 'HUANUO Single Monitor Mount, 13 to 32 Inch Gas Spring Monitor Arm, Adjustable Stand, Vesa Mount with Clamp and Grommet Base',
            imageUrl: "https://m.media-amazon.com/images/I/61fEa-HugSL._AC_SL1500_.jpg",
            altText: '',
            brand: 'HUANUO',
            link: "https://amzn.to/3Vkmgd6",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'This monitor arm frees up so much desk space and lets you adjust your screen perfectly. A must-have for any home office!'
        },
        {
            id: 14,
            title: 'Sakugi Overbed Bedside Table with Wheels, Height Adjustable Rolling Bed Tray, Laptop Desk',
            imageUrl: "https://m.media-amazon.com/images/I/816dTogCHZL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Sakugi',
            link: "https://amzn.to/4hdlW8F",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Perfect for working from the couch or bed! The height adjustable feature and wheels make it super versatile.'
        }
    ];

    const homeGym = [
        {
            id: 1,
            title: 'Barbell Dumbbell Set with Rack | Multiple Options in 150lbs and 210lbs',
            imageUrl: "https://m.media-amazon.com/images/I/71f4Mg4P9fL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Cap Barbell',
            link: "https://amzn.to/3YZKLuy",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Top 5 must have items for your at home gym. Durable and versatile, this barbell dumbbell set is great for home gyms.'
        },
        {
            id: 2,
            title: 'Olympic Bars | Multiple options',
            imageUrl: "https://m.media-amazon.com/images/I/51raRYlUL-L._AC_SL1500_.jpg",
            altText: '',
            brand: 'Cap Barbell',
            link: "https://amzn.to/4fV9K99",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Love the look! A High-quality Olympic bar. Designed for weightlifting and home fitness.'
        },
        {
            id: 3,
            title: 'Ab Workout Equipment, Adjustable Ab Machine Full Body Workout for Home Gym, Strength Training Exercise Equipment for Body Shaping Foldable Waist Trainer Suitable for Beginner Red',
            imageUrl: "https://m.media-amazon.com/images/I/71FR4NefjnL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Flybird',
            link: "https://amzn.to/3V4mgLH",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'This kills. I love this machine at the gym so naturally I want it at home! Ideal for beginners, this adjustable ab machine is perfect for at-home workouts.'
        },
        {
            id: 0,
            title: 'LG StanbyMe 27 inch Monitor (Model: 27ART10AKPL) | 1080p | Touch-Screen | 60Hz | Built-in | Full Swivel | Calming Beige | Portable',
            imageUrl: "https://m.media-amazon.com/images/I/61RsXPAOQ0L._AC_SL1500_.jpg",
            altText: '',
            brand: 'LG',
            link: "https://amzn.to/3CH7Tqg",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Portable and versatile, perfect for work and entertainment.'
        },
        {
            id: 20,
            title: 'NordicTrack T Series: Perfect Treadmills for Home Use, Walking or Running Treadmill with Incline, Bluetooth Enabled, 300 lbs User Capacity',
            imageUrl: "https://m.media-amazon.com/images/I/51H61SeYDkL._AC_SL1001_.jpg",
            altText: '',
            brand: 'NordicTrack',
            link: "https://amzn.to/4eNn3aG",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Top 5 must have items for your at home gym. Perfect for home running or walking, with incline and Bluetooth connectivity.'
        },
        {
            id: 4,
            title: 'Assault AirBike Classic, Black',
            imageUrl: "https://m.media-amazon.com/images/I/81avLZy-hVL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Assault Fitness',
            link: "https://amzn.to/3CEwiwB",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'This kicks your butt. Perfect assistant for cutting. A high-intensity bike for full-body workouts and cardio.'
        },
        {
            id: 5,
            title: 'Hyperbell Dumbbell Converter - Convert Dumbbells to Barbell Set and Kettlebell for Home Fitness - Adjustable & Up to 200 lb Capacity Weight Barbell for Weight Lifting',
            imageUrl: "https://m.media-amazon.com/images/I/615+t8kXNYL._AC_SL1080_.jpg",
            altText: '',
            brand: 'JayFlex',
            link: "https://amzn.to/4940Unf",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Convert your dumbbells to a versatile barbell. This is amazing and so useful for at home lifts!'
        },
        {
            id: 6,
            title: 'Hyperextension Roman Chair - Adjustable Bench Foldable Exercise Bench Back Extension Machine Roman Chair Exercise Equipment for Home',
            imageUrl: "https://m.media-amazon.com/images/I/61XCDPbMJKL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Houbus',
            link: "https://amzn.to/40VQST5",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Primarily targets the lower back. You can add a few effective, tough exercise to your tollbox with this treasure. Adjustable back extender for improving core and lower back strength.'
        },
        {
            id: 7,
            title: 'Kettlebell Handle - Converter for Dumbbell to Kettle Bell - Grip Handle Attachment for Dumbbells',
            imageUrl: "https://m.media-amazon.com/images/I/71GhDi3iK9L._AC_SL1500_.jpg",
            altText: '',
            brand: 'PowerPress',
            link: "https://amzn.to/4hX1ffB",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Opens up the world of possibilities for your home gym. An innovative way to turn your dumbbells into kettlebells for functional training.'
        },
        {
            id: 8,
            title: 'Bumper Plate Olympic Weight Plate Bumper Weight Plate with Steel Insert Strength Training Weight Lifting Plate',
            imageUrl: "https://m.media-amazon.com/images/I/615riQyUCqL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Zoomster',
            link: "https://amzn.to/4hXCu2V",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Must have for a home gym! Durable bumper plates with steel inserts for Olympic weightlifting. The black is perfect too if you care about aesthetic!'
        },
        {
            id: 9,
            title: 'Puzzle Exercise Mat ½ in, EVA Interlocking Foam Floor Tiles for Home Gym, Mat for Home Workout Equipment, Floor Padding for Kids, Black, 24 in x 24 in x ½ in, 144 Sq Ft - 36 Tiles',
            imageUrl: "https://m.media-amazon.com/images/I/91NGIkWUIaL._AC_SL1500_.jpg",
            altText: '',
            brand: 'ProsourceFit',
            link: "https://amzn.to/4eKhDx0",
            isPrimeDayDeal: false,
            isBlackFridayDeal: false,
            why: 'Protect your floors with this interlocking foam exercise mat, perfect for home gyms.'
        },
        {
            id: 10,
            title: 'FMulti-Functional Folding Squat Rack for Home Gym, 2.36\'\' x 2.36\'\' Wall Mounted Squat Rack with Attachments - Space Saving Squat Power Rack',
            imageUrl: "https://m.media-amazon.com/images/I/61eijG2AxiL._AC_SL1500_.jpg",
            altText: '',
            brand: 'RitFit',
            link: "https://amzn.to/4eKxgVn",
            isPrimeDayDeal: false,
            why: 'Space-saving squat rack with pull-up bar for serious home gym workouts.',
            isBlackFridayDeal: false
        },
        {
            id: 11,
            title: 'M1 & M1 Pro Smith Machine with Cable Crossover System, Multi-Function Squat Rack Power Cage for Home Gym, Power Rack and Packages',
            imageUrl: "https://m.media-amazon.com/images/I/81H4CtukEML._AC_SL1500_.jpg",
            altText: '',
            brand: 'RitFit',
            link: "https://amzn.to/40TLYpO",
            isPrimeDayDeal: false,
            why: 'Complete Smith machine with cable system, perfect for strength training at home.',
            isBlackFridayDeal: false
        },
        {
            id: 12,
            title: 'Weight Bench, Adjustable Strength Training Bench for Full Body Workout with Fast Folding-New Version',
            imageUrl: "https://m.media-amazon.com/images/I/71LLGB4onjL._AC_SL1500_.jpg",
            altText: '',
            brand: 'FLYBIRD',
            link: "https://amzn.to/40TLWhG",
            isPrimeDayDeal: false,
            why: 'Adjustable and foldable bench for full-body strength training workouts.',
            isBlackFridayDeal: false
        },
        {
            id: 13,
            title: 'RDX AB Straps for Pull Up Bar Hanging, Maya Hide Leather, Abdominal Muscle Building Padded Arm Support Slings',
            imageUrl: "https://m.media-amazon.com/images/I/71YvP7NWVCL._AC_SL1500_.jpg",
            altText: '',
            brand: 'RDX',
            link: "https://amzn.to/4A3Yan2",
            isPrimeDayDeal: false,
            why: 'Perfect for hanging leg raises and ab work. The padded arm support makes it comfortable even during intense sets!',
            isBlackFridayDeal: false
        }
    ];

    const fashion = [
        {
            id: 0,
            title: 'Women\'s Summer Casual Boho Dress Floral Print Ruffle Puff Sleeve High Waist Midi Beach Dresses',
            imageUrl: "https://m.media-amazon.com/images/I/61KyIKmTXvL._AC_SY879_.jpg",
            altText: '',
            brand: 'Pretty Garden',
            link: "https://amzn.to/410fV7E",
            isPrimeDayDeal: false,
            why: 'Great for casual outings and beach days, and yet perfect for church with your family! A very flattering fit!',
            isBlackFridayDeal: false,
        },
        {
            id: 1,
            title: 'Women Long Satin Summer Fall Skirt Silk Elegant High Waist Cocktail Party Wedding Flared A-Line Midi Skirts',
            imageUrl: "https://m.media-amazon.com/images/I/61pg+NYZelL._AC_SX679_.jpg",
            altText: '',
            brand: 'BTFBM',
            link: "https://amzn.to/4fWGkY5",
            isPrimeDayDeal: false,
            why: 'Perfect for formal events and a very elegant touch to any wardrobe.',
            isBlackFridayDeal: false,
        },
        {
            id: 2,
            title: 'Long Sleeve Shirts for Women Tops Fall Fashion 2024 Trendy Slim fit Textured Tshirts',
            imageUrl: "https://m.media-amazon.com/images/I/81iNRqX2lyL._AC_SX679_.jpg",
            altText: '',
            brand: 'ZESICA',
            link: "https://amzn.to/3ZmbOR5",
            why: 'Stylish and comfortable for layering or wearing alone.',
            isBlackFridayDeal: false,
        },
        {
            id: 3,
            title: 'Women\'s Braided Heeled Sandals Strappy Square Open Toe Heels Backless Mules Slip On Block Heels',
            imageUrl: "https://m.media-amazon.com/images/I/71taJu0DIpL._AC_SY695_.jpg",
            altText: '',
            brand: 'Athlefit',
            link: "https://amzn.to/3Z4sLiH",
            isPrimeDayDeal: false,
            why: 'Chic and versatile, perfect for spring and summer.',
            isBlackFridayDeal: false,
        },
        {
            id: 4,
            title: 'Puffer Vest Women Sleeveless Winter Outerwear Warm Puffer Lightweight Fashion Stand-up Collar Down Vest',
            imageUrl: "https://m.media-amazon.com/images/I/61eU6BIFCgL._AC_SY879_.jpg",
            altText: '',
            brand: 'Trendy Queen',
            link: "https://amzn.to/3CzwvRy",
            isPrimeDayDeal: false,
            why: 'Great for layering during colder months without the bulk.',
            isBlackFridayDeal: false,
        },
        {
            id: 5,
            title: 'Women\'s Long Dressy Cardigan Sweaters Fall Trendy Oversized Coatigan Jackets 2024 Knit Winter Coats',
            imageUrl: "https://m.media-amazon.com/images/I/71Kfv4vWFtL._AC_SY879_.jpg",
            altText: '',
            brand: 'LILLUSORY',
            link: "https://amzn.to/4fDuJh4",
            why: 'Cozy and chic, perfect for layering on colder days.',
            isBlackFridayDeal: false,
        },
        {
            id: 6,
            title: 'Trendy Queen Womens Oversized Sweatshirts Turtleneck Pullover Long Sleeve Hoodies Tops Fall Outfits 2024',
            imageUrl: "https://m.media-amazon.com/images/I/61q70jQfPdL._AC_SY879_.jpg",
            altText: '',
            brand: 'Trendy Queen',
            link: "https://amzn.to/490YoOA",
            isPrimeDayDeal: false,
            why: 'Beautiful and comfortable. I would recommend a size up from your usual, especially if your busty!',
            isBlackFridayDeal: false,
        },
        {
            id: 7,
            title: 'Trendy Queen Long Sleeve Shirts for Women 2024 Fall Fashion V Neck Basics Crop Tops Layering Slim Fitted Y2K Tops',
            imageUrl: "https://m.media-amazon.com/images/I/71-UQ2Jy5iL._AC_SY879_.jpg",
            altText: '',
            brand: 'Trendy Queen',
            link: "https://amzn.to/4ghVl7l",
            isPrimeDayDeal: false,
            why: 'I want more colors, but beige was a perfect first choice for me. The material is incredible. It is a snug fit!',
            isBlackFridayDeal: false,
        },
        {
            id: 11,
            title: 'Women\'s Joggers Pants Lightweight Athletic Leggings Tapered Lounge Pants for Workout, Yoga, Running',
            imageUrl: "https://m.media-amazon.com/images/I/618XtRiWOxL._AC_SY879_.jpg",
            altText: '',
            brand: 'The Gym People',
            link: "https://amzn.to/3YT5uzW",
            isPrimeDayDeal: false,
            why: 'These are one of those items that I want extra pairs just in case. They work at home and as a professional woman! they are so comfy. Love these.',
            isBlackFridayDeal: false,
        },
        {
            id: 12,
            title: 'Women\'s Wide Leg Jeans Casual High Waisted Straight Stretch Denim Pants with Pockets',
            imageUrl: "https://m.media-amazon.com/images/I/71K5bQGuHwL._AC_SY879_.jpg",
            altText: '',
            brand: 'Sidefeel',
            link: "https://amzn.to/3Oo5wLz",
            isPrimeDayDeal: false,
            why: 'Comfy and stylish!',
            isBlackFridayDeal: false,
        },
        {
            id: 8,
            title: 'Color-Block Crossbody Bags for Women Leather Cross Body Purses Cute Designer Handbags Shoulder Bag Medium Size',
            imageUrl: "https://m.media-amazon.com/images/I/71T8EVp49iL._AC_SY695_.jpg",
            altText: '',
            brand: 'Top Band',
            link: "https://amzn.to/4fAvR59",
            why: 'I love the look of it and how it can add a level of sophistication to just about every outfit.',
            isBlackFridayDeal: false,
        },
        {
            id: 9,
            title: 'Quilted Crossbody Bags for Women Vegan Leather PU Purses Small Shoulder Handbags with Adjustable Wide Jacquard Strap',
            imageUrl: "https://m.media-amazon.com/images/I/71e5WGWKgVL._AC_SY695_.jpg",
            altText: '',
            brand: 'NAARIIAN',
            link: "https://amzn.to/40V86Ad",
            why: 'A must have for any mama who needs a hands-free place for your phone and keys. I really like the material and length of the strap!',
            isBlackFridayDeal: false,
        },
        {
            id: 10,
            title: 'Nike Women\'s Court Vision Low Sneaker',
            imageUrl: "https://m.media-amazon.com/images/I/71CZzNC1hqL._AC_SY695_.jpg",
            altText: '',
            brand: 'Nike',
            link: "https://amzn.to/494EEJR",
            why: 'So cute and such a pretty swish color!',
            isBlackFridayDeal: false,
        },
        {
            id: 13,
            title: 'KFUBUO Womens Pajamas Set 2 Piece Ruffle Pj Soft Tank Top and Shorts Sleepwear Set',
            imageUrl: "https://m.media-amazon.com/images/I/71USgJQyCdL._AC_SL1500_.jpg",
            altText: '',
            brand: 'KFUBUO',
            link: "https://amzn.to/4r23y65",
            why: 'The cutest matching pajama set! So soft and comfortable for lounging.',
            isBlackFridayDeal: false,
        },
        {
            id: 14,
            title: 'ANRABESS Maxi Dresses for Women Summer Casual Tank Dress',
            imageUrl: "https://m.media-amazon.com/images/I/61iB3aZrWtL._AC_SL1500_.jpg",
            altText: '',
            brand: 'ANRABESS',
            link: "https://amzn.to/4rkMKrf",
            why: 'Great for pregnancy! This casual maxi dress is so comfortable and flattering through all stages.',
            isBlackFridayDeal: false,
        },
        {
            id: 15,
            title: 'Vertvie Women Seamless Wireless Jelly Bra Comfortable Bralette',
            imageUrl: "https://m.media-amazon.com/images/I/81cfZxDkqrL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Vertvie',
            link: "https://amzn.to/4yrFmwm",
            why: 'Great for pregnancy! Super comfortable wireless bra that grows with you.',
            isBlackFridayDeal: false,
        },
        {
            id: 16,
            title: 'Mingzhu Womens 2 Piece Outfits Skirt Set Summer Casual Cap Sleeve Crop Tops Maxi Dress Sets with Pockets',
            imageUrl: "https://m.media-amazon.com/images/I/61omcu6iWdL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Mingzhu',
            link: "https://amzn.to/3UGJ4DO",
            why: 'Great for pregnancy! This two piece set is so stylish and comfortable with room to grow.',
            isBlackFridayDeal: false,
        },
        {
            id: 17,
            title: 'Glamaker Womens Summer Tshirt Dresses Casual Sleeveless Striped Shift Tank Short Sundress',
            imageUrl: "https://m.media-amazon.com/images/I/717gpFwqLCL._AC_SL1500_.jpg",
            altText: '',
            brand: 'Glamaker',
            link: "https://amzn.to/4yv30Is",
            why: 'Great for pregnancy! Casual and comfortable sundress perfect for warm weather.',
            isBlackFridayDeal: false,
        },
    ];

    const skincare = [
        {
            id: 1,
            title: 'TiZO3 Facial Mineral Sunscreen and Primer, Tinted Broad Spectrum SPF 40 with Antioxidants',
            imageUrl: "https://m.media-amazon.com/images/I/71UEEaIf5IL._SL1500_.jpg",
            altText: '',
            brand: 'TiZO3',
            link: "https://amzn.to/3UBHF1n",
            why: 'My holy grail sunscreen! Sheer matte finish, fragrance-free, and dermatologist-recommended. A must for daily protection.',
            isBlackFridayDeal: false,
        },
        {
            id: 2,
            title: 'Estée Lauder Double Wear Stay-in-Place Foundation Makeup, 36-Hour Long-Wear Oil-Free Liquid Matte Foundation',
            imageUrl: "https://m.media-amazon.com/images/I/61XePFaaBXL._SL1500_.jpg",
            altText: '',
            brand: 'Estée Lauder',
            link: "https://amzn.to/4A0Rjuv",
            why: 'The best long-wear foundation! Hydrating, breathable, and buildable coverage that lasts all day.',
            isBlackFridayDeal: false,
        },
    ];

    const recovery = [
        {
            id: 1,
            title: 'GENIANI Electric Heating Pad for Back Pain & Cramps Relief, Machine Washable Microplush',
            imageUrl: "https://m.media-amazon.com/images/I/91TwwNwGvfL._AC_SL1500_.jpg",
            altText: '',
            brand: 'GENIANI',
            link: "https://amzn.to/4xhFNZd",
            why: 'A lifesaver for sore muscles and cramps! Auto shut off and machine washable.',
            isBlackFridayDeal: false,
        },
        {
            id: 2,
            title: 'AUVON Dual Channel TENS Unit Muscle Stimulator Machine with 20 Modes',
            imageUrl: "https://m.media-amazon.com/images/I/714V7Ir-4lL._AC_SL1500_.jpg",
            altText: '',
            brand: 'AUVON',
            link: "https://amzn.to/4xDlwya",
            why: 'Game changer for muscle pain relief! Multiple modes and easy to use electrode pads.',
            isBlackFridayDeal: false,
        },
        {
            id: 3,
            title: 'Nekteck Shiatsu Neck Massager with Heat for Pain Relief, 3D Back Shoulder Kneading Massage Pillow',
            imageUrl: "https://m.media-amazon.com/images/I/71i9CgTPU0L._AC_SL1500_.jpg",
            altText: '',
            brand: 'Nekteck',
            link: "https://amzn.to/4gUUGKR",
            why: 'The best neck massager! Deep tissue kneading with heat - perfect after a long day.',
            isBlackFridayDeal: false,
        },
    ];

    const toddlerFinds = [
        {
            id: 1,
            title: 'BEKILOLE Montessori Toys 11.8" Laptop Preschool Learning Activities, Educational Toys for 3-8 Year Old Kids',
            imageUrl: "https://m.media-amazon.com/images/I/71-cu+R1+FL._AC_SL1500_.jpg",
            altText: '',
            brand: 'BEKILOLE',
            link: "https://amzn.to/4xJXamj",
            why: 'Perfect for little ones who want to be just like mom and dad! Pretend play laptop with learning activities.',
            isBlackFridayDeal: false,
        },
    ];

    return (
        <section className="" id="products">
            <ProductCategory products={officeSupplies} categoryTitle="Office Finds"/>
            <ProductCategory products={homeGym} categoryTitle="Home Gym"/>
            <ProductCategory products={equipment} categoryTitle="Equipment"/>
            <ProductCategory products={supplements} categoryTitle="Supplements"/>
            <ProductCategory products={proteins} categoryTitle="Protein Supplements"/>
            <ProductCategory products={fits} categoryTitle="Gym Fits"/>
            <ProductCategory products={supplies} categoryTitle="Supplies"/>
            <ProductCategory products={fashion} categoryTitle="Fashion"/>
            <ProductCategory products={skincare} categoryTitle="Skincare Routine"/>
            <ProductCategory products={recovery} categoryTitle="Recovery"/>
            <ProductCategory products={toddlerFinds} categoryTitle="Little Genius Finds"/>
        </section>
    );
}

export default ProductsSection;